import React from "react";
import { View } from "react-native";
import Placeholder from "../../general/Placeholder/Placeholder";
import AiTutorCardProgress from "../AiTutorCardProgress/AiTutorCardProgress";
import AxioResourceCard from "../../customCoursework/AxioResourceCard/AxioResourceCard";
import { MotiView } from "moti";
import { LinkBlue, DocumentBlue } from "../../svgs/CustomCoursework";
import { SparkleBlue } from "../../svgs/common";

function AiTutorCardProgressList({ items = [], onPress, onHoverIn, onHoverOut }) {
  const resourceTypeToIcon = {
    axioResource: <LinkBlue width={24} height={24} />,
    aiTutor: <SparkleBlue width={24} height={24} fill="#3E68FE" />,
    assignment: <DocumentBlue width={24} height={24} />,
  };

  const renderResourceCard = (item, index) => {
    const icon = resourceTypeToIcon[item.resourceType];
    if (item.resourceType === "axioResource" || item.resourceType === "assignment") {
      return (
        <MotiView
          key={item.id}
          from={{
            opacity: 0,
            translateY: 20,
            scale: 0.95,
          }}
          animate={{
            opacity: 1,
            translateY: 0,
            scale: 1,
          }}
          delay={300 + index * 300}
          transition={{ type: "timing", duration: 800 }}>
          <AxioResourceCard
            title={item.details.title}
            description={item.details.description}
            videoUrl={item.details.videoUrl}
            icon={icon}
            files={item.files}
            isHovered={item.isHovered}
            onPress={() => onPress(item.id)}
            onHoverIn={() => onHoverIn(item.id)}
            onHoverOut={() => onHoverOut(item.id)}
          />
        </MotiView>
      );
    }

    return (
      <MotiView
        key={item.id}
        from={{
          opacity: 0,
          translateY: 20,
          scale: 0.95,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
          scale: 1,
        }}
        delay={300 + index * 300}
        transition={{ type: "timing", duration: 800 }}>
        <AiTutorCardProgress
          title={item.title}
          isHovered={item.isHovered}
          isComplete={item.details?.isComplete}
          totalObjectives={item.details?.totalObjectives}
          icon={icon}
          completedObjectives={item.details?.completedObjectives}
          onPress={() => onPress(item.id)}
          onHoverIn={() => onHoverIn(item.id)}
          onHoverOut={() => onHoverOut(item.id)}
        />
      </MotiView>
    );
  };

  return (
    <View>
      {items.length > 0 ? (
        <>{items.map(renderResourceCard)}</>
      ) : (
        <View style={{ flex: 1, justifyContent: "center" }}>
          <Placeholder subtitle="Visit your Learning Management System to access these resources" />
        </View>
      )}
    </View>
  );
}

export default AiTutorCardProgressList;
